import {Botao, PaginaLogada, SelectFetch} from "../../componentes";
import {useEffect, useRef, useState} from "react";
import {formatarDinheiro, formatarDinheiroParaDecimal, formatarTelefone, somenteNumeros} from "../../util/mascara";
import {exibirMensagemAlerta, exibirMensagemErro, exibirMensagemSucesso, HttpVerbo, USUARIO, xfetch} from "../../util";
import CardPadrao from "../../componentes/card/card-padrao";
import {DemandaCmd} from "../../tipos/cmd/demanda-cmd";
import {ItemDemandaCmd} from "../../tipos/cmd/item-demanda-cmd";

export default function NovaDemanda() {


  const itemsRef = useRef()
  const [demanda, setDemanda] = useState(new DemandaCmd())
  const [itens, setItens] = useState<ItemDemandaCmd[]>([])
  const [total, setTotal] = useState(0.00)
  const [isCarregando, setIsCarregando] = useState(false)
  const [forca, setForca] = useState('')

  const [itemTmp, setItemTmp] = useState(new ItemDemandaCmd())

  function inserirItem() {
    if (!itemTmp.quantidade || !itemTmp.valorUnitario) {
      exibirMensagemErro('Insira todos os campos do item')
      return
    }
    itemTmp.valorUnitario = formatarDinheiroParaDecimal(itemTmp.valorUnitario)
    setItens([...itens, itemTmp])
    setTotal(total+ (itemTmp.quantidade * formatarDinheiroParaDecimal(itemTmp.valorUnitario)))
    setItemTmp(new ItemDemandaCmd())
    console.log(itemsRef)
  }

  function validaItens() {
    const itensInvalidos = itens.filter(i => !i.id || !i.quantidade || !i.valorUnitario);
    return !(itensInvalidos.length > 0)
  }

  function limparDemanda() {
    setDemanda(new DemandaCmd())
    setItens([])
    setTotal(0.00)
    setItemTmp(new ItemDemandaCmd())
  }

  function cadastrarDamanda() {
    setIsCarregando(true)
    if (!validaItens()) {
      exibirMensagemErro("Remova os itens e inclua novamente")
      setIsCarregando(false)
      return;
    }
    const dados = {
      forca: getForca(),
      delegacia: demanda.delegaciaId,
      unidade: demanda.unidade,
      telefone: demanda.telefone,
      objeto: demanda.objeto,
      itens: itens,
      justificativa: demanda.justificativa,
      resultadoEsperado: demanda.resultado
    }
    const resposta = window.confirm('Deseja cadastrar a demanda?')
    if (!resposta) {
      exibirMensagemAlerta("Ação cancelada")
      setIsCarregando(false)
      return
    }

    xfetch('/demanda', dados, HttpVerbo.POST)
      .then(response => response.json())
      .then(res => {
        exibirMensagemSucesso("Demanda cadastrada com sucesso")
        limparDemanda()
      })
      .catch(() => exibirMensagemErro("Erro ao cadastrar demanda"))
      .finally(() => setIsCarregando(false))

  }

  function removeItem(indice: number) {
    const arr = itens.filter((v, k) => k !== indice)
    setItens(arr)
    if (arr.length === 0) setTotal(0.00)
    let valor = 0;
    arr.forEach(v => valor += (v.quantidade * formatarDinheiroParaDecimal(v.valorUnitario)))
    setTotal(valor)
  }

  function getForca() {
    let usuario = JSON.parse(localStorage.getItem(USUARIO) as string);
    return usuario.email.split('@')[1].split('.')[0].toString().toUpperCase();
  }

  function getUnidade() {
    if (forca === 'PC' || forca === 'SSP') {
      return <div className="col-lg-4">
        <label>Unidade requerente:</label>
        <SelectFetch
          url={"/delegacia/ativa"}
          setIsCarregando={setIsCarregando}
          handleChange={(e: any) => setDemanda({...demanda, delegaciaId: e.value})}
          placeholder='Selecione a Delegacia'
        />
      </div>
    } else {
      return <div className="col-lg-4">
        <label>Unidade requerente:</label>
        <input
          value={demanda.unidade}
          className="form-control"
          onChange={(e) => setDemanda({...demanda, unidade: e.target.value.toUpperCase()})}/>
      </div>
    }
  }

  useEffect(() => {
    setForca(getForca())
  })

  return (
    <PaginaLogada titulo="Criar Demanda" isCarregando={isCarregando}>
      <CardPadrao titulo="Dados básicos">
        <div className="row">
          <div className="col-lg-4">
            <label>Força:</label>
            <input
              value={forca}
              disabled={true}
              className="form-control"/>
          </div>
          {getUnidade()}
          <div className="col-lg-4">
            <label>Telefone:</label>
            <input
              value={demanda.telefone}
              className="form-control"
              onChange={(e) => setDemanda({...demanda, telefone: formatarTelefone(e.target.value)})}/>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-12">
            <label>Contexto da demanda e justificativa da necessidade da contratação pública (art. 22, I “a” e “c”, do Decreto Estadual nº 342/2023):</label>
            <textarea
              value={demanda.objeto}
              rows={10}
              className="form-control"
              onChange={(e) => setDemanda({...demanda, objeto: e.target.value.toUpperCase()})}/>
            <span className="small text-danger">Finalidade</span>
          </div>
        </div>
      </CardPadrao>

      <CardPadrao titulo="Itens">
        <div className="row mt-2">
          <div className="col-lg-7">
            <label>Item:</label>
            <SelectFetch
              ref={itemsRef}
              url={'/demanda/itens'}
              setIsCarregando={setIsCarregando}
              handleChange={(e: any) => setItemTmp({...itemTmp, id: e?.value, nome: e?.label})}
              placeholder="Selecione o item"/>
          </div>
          <div className="col-lg-2">
            <label>Qtd:</label>
            <input placeholder="Quantidade"
              className="form-control" value={itemTmp.quantidade}
              onChange={(e) => setItemTmp({...itemTmp, quantidade: Number(e.target.value)})}/>
          </div>
          <div className="col-lg-3">
            <label>Preço unit:</label>
            <input placeholder="Preço unitário"
              className="form-control"
              value={formatarDinheiro(itemTmp.valorUnitario)}
              onChange={(e) => setItemTmp({...itemTmp, valorUnitario: somenteNumeros(e.target.value)})}/>
          </div>
        </div>
        <div className="row mb-5">
          <div className={'col-lg-4 ' + (itemTmp.id === 129 ? '' : 'd-none')}>
            <label>Nome do item:</label>
            <input placeholder="Nome do item"
              className="form-control" value={itemTmp.especificacao}
              onChange={(e) => setItemTmp({...itemTmp, especificacao: e.target.value.toUpperCase()})}/>
          </div>
          <div className="col-lg-3 mt-4">
          <span className="text-white btn btn-success rounded-pill" onClick={inserirItem}>
            Add Item <i className="text-white bi bi-plus-circle"/>
          </span>
          </div>
        </div>

          <div className="row">
            <div className="col-lg-12">
              <table className="table table-responsive-lg">
              <thead>
              <tr>
                <th style={{"width": "10px"}}>item</th>
                <th>Nome</th>
                <th>Especificação</th>
                <th>Qtd</th>
                <th>Preço unitário</th>
                <th>Ação</th>
              </tr>
              </thead>

              <tbody>
                {itens.map((v, k) => {
                  return (
                    <tr key={v.id}>
                      <td>{k + 1}</td>
                      <td>{v.nome}</td>
                      <td>{v.especificacao}</td>
                      <td>{v.quantidade}</td>
                      <td>
                        <b>R$ {formatarDinheiro(v.valorUnitario)}</b>
                        </td>
                      <td>
                        <span className="text-danger" onClick={(e) => removeItem(k)}>
                          <i className="bi bi-trash2"></i>
                        </span>
                      </td>
                    </tr>
                  )
                })}

              </tbody>
            </table>
            </div>
          </div>

          <div className="col-12 pull-right">
            <label className="text-end"> <b>Valor total - R$ {formatarDinheiro(total.toFixed(2))}</b></label>
          </div>

      </CardPadrao>

      <CardPadrao titulo="Motivação/Justificativa da Demanda">
        <div className="row">
          <div className="col-12">
            <textarea
              className="form-control"
              value={demanda.justificativa}
              rows={10}
              onChange={(e) => setDemanda({...demanda, justificativa: e.target.value.toUpperCase()})}>
            </textarea>
          </div>
        </div>
      </CardPadrao>

      <CardPadrao titulo="Resultados Pretendidos">
        <div className="row">
          <div className="col-12">
            <textarea className="form-control"
              value={demanda.resultado}
              rows={10}
              onChange={(e) => setDemanda({...demanda, resultado: e.target.value.toUpperCase()})}>
            </textarea>
          </div>
        </div>
      </CardPadrao>
      <div className="row">
        <div className="text-center">
          <Botao cor="success" tamanho="col-lg-4" className="rounded-pill" onClick={cadastrarDamanda}> Cadastrar Demanda</Botao>
        </div>

      </div>
    </PaginaLogada>
  );
}
